import { defineStore } from 'pinia'

export const useUiStore = defineStore('ui', {
  state: () => ({
    composerOpen: false,
    composerTopicId: 0,      // 预选话题
    composerTopicTitle: '',
    composerEditPost: null,  // 编辑态：待编辑的帖子（至少含 id）；为 null 表示新建
    toast: null,             // { type, msg }
    currentTopic: null,      // 话题页当前话题 { id, slug, title, icon }（顶级母话题）
    currentNode: null,       // 话题页当前下钻选中的子话题 { id, title }；null=未下钻(发帖到母话题)
    theme: 'light',          // 'light' | 'dark'，日/夜间模式
    // 用户资料浮动卡（点头像弹出）
    profileCardOpen: false,
    profileCardAuthor: null,   // 完整作者对象 {id,username,avatar,level,is_virtual?}
    profileCardRefTime: null,  // 帖子/评论 create_time（虚拟用户推算注册时间用）
    profileCardAnchor: null,   // 点击头像的 getBoundingClientRect()，用于贴边定位
    // 私信全局浮层
    dmModalOpen: false,
    dmTargetUser: null,        // 打开时定位的用户 {id,username,avatar}；null=仅显示会话列表
  }),
  actions: {
    setCurrentTopic(topic) {
      this.currentTopic = topic
    },
    setCurrentNode(node) {
      this.currentNode = node
    },
    clearCurrentTopic() {
      this.currentTopic = null
      this.currentNode = null
    },
    openComposer(topicId = 0, topicTitle = '') {
      this.composerEditPost = null   // 新建模式
      this.composerTopicId = topicId
      this.composerTopicTitle = topicTitle
      this.composerOpen = true
    },
    openEditComposer(post) {
      this.composerEditPost = post
      this.composerTopicId = 0
      this.composerTopicTitle = ''
      this.composerOpen = true
    },
    closeComposer() {
      this.composerOpen = false
      this.composerEditPost = null
    },
    // —— 用户资料浮动卡 ——
    // author：完整作者对象（含 is_virtual 标识虚拟身份）；refTime：帖子/评论创建时间
    openProfileCard(author, anchorEl = null, refTime = null) {
      this.profileCardAuthor = author
      this.profileCardRefTime = refTime
      // 存 DOMRect 快照（元素可能在关闭前被卸载，故取快照而非引用）
      this.profileCardAnchor = anchorEl ? anchorEl.getBoundingClientRect() : null
      this.profileCardOpen = true
    },
    closeProfileCard() {
      this.profileCardOpen = false
      this.profileCardAuthor = null
      this.profileCardRefTime = null
      this.profileCardAnchor = null
    },
    // —— 私信浮层 ——
    openDmModal(user = null) {
      this.dmTargetUser = user
      this.dmModalOpen = true
    },
    closeDmModal() {
      this.dmModalOpen = false
      this.dmTargetUser = null
    },
    showToast(msg, type = 'info') {
      this.toast = { msg, type, t: Date.now() }
      setTimeout(() => { this.toast = null }, 2600)
    },
    // —— 日/夜间模式 ——
    // 读取已存偏好，否则跟随系统 prefers-color-scheme；同步到 <html data-theme>
    initTheme() {
      let t = localStorage.getItem('crirp-theme')
      if (t !== 'light' && t !== 'dark') {
        t = (window.matchMedia && window.matchMedia('(prefers-color-scheme: dark)').matches) ? 'dark' : 'light'
      }
      this.theme = t
      this._applyTheme()
    },
    setTheme(t) {
      this.theme = t
      try { localStorage.setItem('crirp-theme', t) } catch (e) { /* ignore */ }
      this._applyTheme()
    },
    toggleTheme() {
      this.setTheme(this.theme === 'dark' ? 'light' : 'dark')
    },
    _applyTheme() {
      if (typeof document !== 'undefined') {
        document.documentElement.dataset.theme = this.theme
      }
    },
  },
})
